// extracted by css-extract-rspack-plugin
export default {"cls1":"MobileChipize-cls1_lno","cls2":"MobileChipize-cls2_5kv MobileChipize-cls1_lno"};